import styled from 'styled-components'
import { Group as ReakitGroup } from 'reakit/Group'

export const Group = styled(ReakitGroup)({
  display: 'flex',

  '& > *': {
    flex: 1,
    padding: 0,
  },

  '& > :not(:first-child)': {
    marginLeft: -1,
  },

  '& > :last-child:not(:first-child)': {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  },
})
